import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import "bootstrap/dist/css/bootstrap.min.css";
import "./../../App.css";
import { useHeader } from './../../components/HeaderContext';
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate";
import useAuth from "./../../hooks/useAuth.js";
import { useAlert } from './../../components/AlertContext.jsx';

const GroupsAdd = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const { triggerAlert } = useAlert();

    const ReturnPage = "/groups";

    //console.log("groups_add.js > START > auth: ", JSON.stringify(auth));

    // texto do cabeçalho da pagina
    const { setHeader } = useHeader();
    useEffect(() => {
        setHeader("Group Add");
    }, [setHeader]);

    const last_modified_date = format(Date(), "dd-MM-yyyy HH:mm:ss");
    const last_modified_user_id = auth.user_id ? auth.user_id : 0;

    //para guardar os valores dos campos
    const [formData, setFormData] = useState({
        group_id: '',
        group_name: '',
        description: '',
        company_id: '',
        last_modified_date: last_modified_date,
        last_modified_user_id: last_modified_user_id
    })

    // controla de o registo foi gravado ou nao na base de dados
    const [isSubmitted, setIsSubmitted] = useState(false);

    const navigate = useNavigate();


    const handleSubmitAdd = async (e) => {
        e.preventDefault();

        try {
            console.log("handleSubmitAdd 1");
            await axiosPrivate.post(`${baseURL}/groups`, formData)
                .then(result => {
                    console.log("groups_add.js > handleSubmitAdd > result.data: ", result.data);
                    // If successfully added to the database, update state to disable input fields
                    setIsSubmitted(true);

                    let message = `Record Saved! \n Codigo: ${result.data.grupo}`;
                    triggerAlert(message, 'success');

                    navigate(ReturnPage);
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response.data.err.originalError.info.message);
                        let message = `Erro na gravação!  \n ${err.response.data.err.originalError.info.message}`;
                        triggerAlert(message, 'error');
                    }
                    else {
                        let message = `Erro na gravação!`;
                        triggerAlert(message, 'error');
                    }
                })
        }
        catch (err) {
            console.error('Error adding record:', err);
            let message = `Erro na gravação!  \n ${err}`;
            triggerAlert(message, 'error');
        }
    }



    return (
        <div className="d-flex align-items-center mt-1">
            <div className="p-2 rounded w-50">
                <form className="row g-1" onSubmit={handleSubmitAdd}>
                    <div className="col-12 interno">
                        <label className="form-label app_font1 mt-3 required" htmlFor="company_id">company_id</label>
                        <input type="text" name="company_id" value="L" className="form-control form-control-sm app_font1" required disabled
                            onChange={(e) => setFormData({ ...formData, company_id: e.target.value })} />
                    </div>
                    <div className="col-12">
                        <label htmlFor="group_name" className="form-label mt-3 app_font1 required" >Group name</label>
                        <input type="text" name="group_name" className="form-control form-control-sm app_font1" maxLength="30" required
                            disabled={isSubmitted}
                            onChange={(e) => setFormData({ ...formData, group_name: e.target.value })} />
                    </div>
                    <div className="col-12">
                        <label htmlFor="description" className="form-label mt-3 app_font1 required">Description</label>
                        <input type="text" name="description" className="form-control form-control-sm app_font1" maxLength="50" required
                            disabled={isSubmitted}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
                    </div>


                    <div className="col-12 interno">
                        <label className="form-label mt-3 app_font1 required" htmlFor="last_modified_date">last_modified_date</label>
                        <input type="text" name="last_modified_date" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.last_modified_date}
                            onChange={(e) => setFormData({ ...formData, last_modified_date: e.target.value })} />
                    </div>
                    <div className="col-12 interno">
                        <label className="form-label mt-3 app_font1 required" htmlFor="last_modified_user_id">last_modified_user_id</label>
                        <input type="text" name="last_modified_user_id" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.last_modified_user_id}
                            onChange={(e) => setFormData({ ...formData, last_modified_user_id: e.target.value })} />
                    </div>
                    <div className="mt-3">
                        <button type="submit" className="btn btn-success" disabled={isSubmitted} style={{ marginRight: '20px', marginTop: '10px' }}>Save</button>
                        <button className="btn btn-outline-success" style={{ marginRight: '20px', marginTop: '10px' }} onClick={() => navigate(ReturnPage)}>Cancel</button>

                    </div>
                </form>
            </div>
        </div>
    )
}

export default GroupsAdd